import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/timing_2024/custom_rule_settings.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/timing_2024/timer.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/api/GameAPIContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/blog/SubscribeToRoyalListPrompt.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/env/EnvContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/layout/ShareButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
